import {CardHeader} from "reactstrap";
import CardHeaderDropDown from "./CardHeaderDropDown";
import { CommonCardHeaderProps } from "../../../Types/CommonComponent.type";
import { H4 } from "../../../AbstractElements";

const CommonCardHeader = ({
  headClass,
  title,
  titleClass,
  mainTitle,
  dropDownList,
  subClass
}: CommonCardHeaderProps) => {
  return (
    <CardHeader className={headClass}>
      <div className={`header-top ${subClass}`}>
        <H4 className={titleClass}>{title}</H4>
        {mainTitle && (<CardHeaderDropDown dropDownList={dropDownList} mainTitle={mainTitle} ></CardHeaderDropDown>)}
      </div>
    </CardHeader>
  );
};

export default CommonCardHeader;
